export default "__VITE_ASSET__CfDIhuz6__"